import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { StockTakeSessionReportLineModel } from '../../../../../../models/aggregates/erp/stock';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { StockTakeSessionReportLineCriteriaModelQuery, StockTakeSessionReportLineQueryCriteriaClass } from '../../../criteria/stock';

@Injectable({ providedIn: 'root' })
export class StocktakeReportLineService extends BaseApiTemplateService<StockTakeSessionReportLineModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-report-line';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'stocktake-report-line';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'stocktake-report-line';
    this.httpClient = theHttp;
  }

  updateMultiStockTakeSessionReport(dtoObject: StockTakeSessionReportLineModel[],visa: ApiVisa)
  {
    let url = this.apiUrl + '/multi';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/multi';
    }
    return this.httpClient.put<ApiResponseModel<StockTakeSessionReportLineModel[]>>(url, dtoObject, this.getHttpHeader(visa));
  }

  updateMultiStockTakeSessionReportPromise(dtoObject: StockTakeSessionReportLineModel[],visa: ApiVisa)
  {
    let url = this.apiUrl + '/multi';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/multi';
    }
    return this.httpClient.put<ApiResponseModel<StockTakeSessionReportLineModel[]>>(url, dtoObject, this.getHttpHeader(visa))
    .toPromise();
  }

  getStocktakeReportLineByCriteria(visa: ApiVisa, criteria?: StockTakeSessionReportLineQueryCriteriaClass):
    Observable<PagingResponseModel<StockTakeSessionReportLineModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const stockTakeSessionReportLineCriteria = new StockTakeSessionReportLineCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<StockTakeSessionReportLineModel>>(this.apiUrl + '/query?' + stockTakeSessionReportLineCriteria.query, this.getHttpHeader(visa));
  }

}
